import React, { Component, Fragment } from "react";
import { Row, Card, Badge, CardBody, Label, Button } from "reactstrap";
import { injectIntl } from "react-intl";
import moment from "moment";
import { connect } from "react-redux";
import { Colxx, Separator } from "../common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import {
  getRequestListDelta,
  getRequestListWithOrder,
  getRequestListSearch,
  selectedRequestItemsChange,
  getRequestListWithFilter
} from "../../redux/request/actions";
import { getRequestRestaurant } from "../../redux/alacarte/actions";
import RestaurantsModal from "./RestaurantsModal";
import ScrollButton from "../../components/gotoTopScrollButton/ScrollButton";

class Restaurants extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
      displayOptionsIsOpen: false,
      selectedOption: "",
      selectedOptionLabelOver: "",
      selectedOptionLabelTop: "",
      startDate: null,
      startDateLabelOver: null,
      startDateLabelTop: null,
      startDateTime: null,
      startDateRange: null,
      endDateRange: null,
      embeddedDate: moment(),
      tags: [],
      tagsLabelOver: [],
      tagsLabelTop: [],

      visible: false,
      modal: false,

      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      price: "",
      id: "",
      name: "",
      config: "",
      restaurantID: "",
      daysWithSorting: []
    };
  }

  static getDerivedStateFromProps({ getRestaurants }) {
    const daySort = (a, b) => {
      const daysOfWeek = ["mondays", "tuesdays", "wednesdays", "thursdays", "fridays", "saturdays", "sundays"];
      return daysOfWeek.indexOf(a) - daysOfWeek.indexOf(b);
    };
    let daysWithSortingg;
    getRestaurants.map((res, index) => {
      if (res.config && res.config.time_slots) {
        return (daysWithSortingg = Object.keys(res.config.time_slots).sort(daySort));
      }
      return (daysWithSortingg = ["mondays", "tuesdays", "wednesdays", "thursdays", "fridays", "saturdays", "sundays"]);
    });
    return {
      daysWithSorting: daysWithSortingg
    };
    // this.setState({
    //   daysWithSorting: daysWithSortingg
    // });
  }

  toggle = id => {
    if (id) {
      this.setState({
        modal: !this.state.modal,
        restaurantID: id
      });
    } else {
      this.setState({
        modal: !this.state.modal
      });
    }
  };

  modalRestaurants = (id, name, config) => {
    this.toggle(id);
    if (config) {
      this.setState({
        id,
        name,
        config
      });
    } else {
      this.setState({
        id,
        name,
        config: ""
      });
    }
  };

  render() {
    // const { messages } = this.props.intl;
    let List;
    let Loading;
    let No_restaurant;
    if (
      this.props.alacarteApp.getRestaurantLoading === true &&
      this.props.alacarteApp.getRestaurantError === "" &&
      (Object.keys(this.props.alacarteApp.getRestaurants).length === 0 || this.props.alacarteApp.getRestaurants === [])
    ) {
      Loading = <div className="loading" />;
    }
    if (
      this.props.alacarteApp.getRestaurantLoading === false &&
      Object.keys(this.props.alacarteApp.getRestaurants).length > 0 &&
      this.props.alacarteApp.getRestaurantError === ""
    ) {
      List = (
        <div>
          <Row>
            {this.props.alacarteApp.getRestaurants.map((res, index) => (
              <Colxx key={index} xxs="12" lg="4" className="mb-1">
                <Card className="mb-1">
                  <div className="position-absolute card-top-buttons">
                    {res.config ? (
                      <Button
                        onClick={() => this.modalRestaurants(res.id, res.name, res.config)}
                        type="button"
                        className="btn flex-grow-1"
                        color="outline-secondary"
                        size="xs"
                      >
                        + <i className="simple-icon-pencil" style={{ fontSize: "15px" }} />
                      </Button>
                    ) : (
                      <Button
                        onClick={() => this.modalRestaurants(res.id, res.name)}
                        type="button"
                        className="btn flex-grow-1"
                        color="outline-secondary"
                        size="xs"
                      >
                        + <i className="simple-icon-pencil" style={{ fontSize: "15px" }} />
                      </Button>
                    )}
                  </div>
                  <div alt="Detail" className="card-img-top request_color closed">
                    <h3 className="text-center align-middle w-100 mt-3 mb-3">{res.name}</h3>
                  </div>
                  <CardBody>
                    {res.config ? (
                      <div>
                        <p className="text-muted text-small mb-2">
                          {/* <IntlMessages id="pages.description" /> */}
                          <IntlMessages id="alacarte.days" />
                        </p>
                        {/* Object.keys(res.config.time_slots) */}
                        {/* this.state.daysWithSorting */}
                        {Object.keys(res.config.time_slots).map((dayName, index) => {
                          return (
                            <div key={index}>
                              {res.config.time_slots[dayName].length > 0 ? (
                                <Badge color="outline-secondary mb-1 mr-1" pill>
                                  <IntlMessages id={`alacarte.${dayName}`} />
                                </Badge>
                              ) : (
                                ""
                              )}

                              {res.config.time_slots[dayName].map((res, index) => {
                                return (
                                  <div key={index}>
                                    <p className="mb-2">
                                      {res.opens_at} - {res.closes_at} - <IntlMessages id="alacarte.quota" />: {res.quota}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                        <hr />
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.stop_res_before_opens_at" />: {res.config.stop_reservation_before_opens_at}
                        </p>
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.guest_cancel_res_before_open_at" />: {res.config.guest_can_cancel_reservation_before_opens_at}
                        </p>
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.max_guest_count" />: {res.config.max_guest_count}
                        </p>
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.main_course" />:{" "}
                          {res.config.main_course_selection_required === true ? (
                            <IntlMessages id="alacarte.yes" />
                          ) : (
                            <IntlMessages id="alacarte.no" />
                          )}
                        </p>
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.guest_one_res_each_day" />:{" "}
                          {res.config.guest_can_one_reservation_each_day === true ? (
                            <IntlMessages id="alacarte.yes" />
                          ) : (
                            <IntlMessages id="alacarte.no" />
                          )}
                        </p>
                        <p className="mb-2 mt-1">
                          <IntlMessages id="alacarte.guest_one_res_per_resturant" />:{" "}
                          {res.config.guest_can_one_reservation_per_restaurant === true ? (
                            <IntlMessages id="alacarte.yes" />
                          ) : (
                            <IntlMessages id="alacarte.no" />
                          )}
                        </p>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <i className="iconsminds-inbox-empty text-muted" style={{ fontSize: "25px" }} />
                        <Label className="list-item-heading mb-2 text-muted">
                          <IntlMessages id="alacarte.no_config" />
                        </Label>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Colxx>
            ))}
          </Row>
        </div>
      );
    }
    if (
      this.props.alacarteApp.getRestaurantLoading === false &&
      this.props.alacarteApp.getRestaurants.length === 0 &&
      this.props.alacarteApp.getRestaurantError !== ""
    ) {
      No_restaurant = (
        <div style={{ textAlign: "center" }}>
          <i className="iconsminds-inbox-empty text-muted" style={{ fontSize: "25px" }} />
          <Label className="list-item-heading mb-2 text-muted">
            <IntlMessages id="alacarte.no_restaurants" />
          </Label>
        </div>
      );
    }
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <h1 className="text-center align-middle w-100">
              <IntlMessages id="alacarte.restaurants_header" />
            </h1>
            <Separator className="mb-5" />
          </Colxx>
          {/* <RestaurantsModal modal={this.state.modal} toggle={this.toggle}/> */}
          <RestaurantsModal
            modal={this.state.modal}
            restaurantID={this.state.restaurantID}
            toggle={this.toggle}
            id={this.state.id}
            name={this.state.name}
            config={this.state.config}
          />
        </Row>
        {List}
        <ScrollButton />
        {Loading}
        {No_restaurant}
        {/* {PermissonError}
        {List}
        {Loading} */}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ requestApp, alacarteApp, settings, auth }) => {
  const { userPrivileges } = auth;
  const { getRestaurants } = alacarteApp;
  const { locale, hotelConfig } = settings;
  return { requestApp, alacarteApp, locale, hotelConfig, userPrivileges, getRestaurants };
};
export default injectIntl(
  connect(
    mapStateToProps,
    {
      getRequestListDelta,
      getRequestListWithOrder,
      getRequestListSearch,
      getRequestListWithFilter,
      selectedRequestItemsChange,
      getRequestRestaurant,
    }
  )(Restaurants)
);
